import {OPEN_CLOSE_HELP_PAGES} from '../constants/actionTypes';

export function openCloseHelpPages() {
    return {type: OPEN_CLOSE_HELP_PAGES};
}



// WEBPACK FOOTER //
// ./src/actions/helpPagesActions.js